//@helpers
const actionTypes =  require('constants/contactCenter/actionTypes');
const { getSecurityDataValid, authorizeBizumRequest} = require('utilities/contactCenter/bizumActionsHelper');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost  } = require('utilities/APIRequestHelper');

//@core
const { formatText } = require('core/i18n').i18n;

//constants
const {  ERROR_REGISTER_BIZUM_SUCCESSFUL, ERROR_USER_REGISTERED_IN_OTHER_ENTITY, ERROR_BAD_REQUEST } = require('constants/contactCenter/errorTypes');

// @utilities
const { recordLinkV2 } = require("utilities/tagging");
const {
    SEND_TERMS_AND_CONDITIONS_BUTTON,
    BIZUM_NEW_CUSTOMER,
    CLICK_BUTTON_ACTION,
    SEND_INFORMATION_BY_MAIL_BUTTON,
    FAILED_TO_SEND_MAIL_MESSAGE,
    FAILED_TO_SEND_MAIL,
    VIEW_MESSAGE
} = require("constants/tagging");

const taggingEvent = ({ categoriaEvento, accionEvento, etiquetaEvento, errorCategory, errorDescription }) => {
    recordLinkV2({
        categoriaEvento,
        accionEvento,
        etiquetaEvento,
        errorCategory, 
        errorDescription
    })
}    

const setVisibleStep = (step) => {
    return {
        type: actionTypes.BIZUM_REGISTER__SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

const validateUIStep = step => ({
    type: actionTypes.BIZUM_REGISTER__VALIDATE_UI_STEP,
    payload: {
        step
    }
});

const validateSetStep = (step) => (dispatch, getState) => {

    const valid = getState().authorizeBizum.get('steps').get(step-1).get('valid');
    let visibleStep = getState().authorizeBizum.get('visibleStep');
    if(valid){
        visibleStep++;
    }
    dispatch(setVisibleStep(visibleStep));
};

const validateStep = step => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateSetStep(step));
};

const onAccountChange = (account) => {
    return {
        type: actionTypes.BIZUM_REGISTER__SET_ACCOUNT,
        payload: {
            account
        }
    }
}

const onAcceptTermsAndConditions = (terms) => {
    return {
        type: actionTypes.BIZUM_REGISTER__SET_TERMS_CONDITIONS,
        payload: {
            terms
        }
    }
}

const requestAccessDataInProgress = () => {
    return {
        type: actionTypes.BIZUM_REGISTER_TERMS_CONDITIONS_REQUEST
    }
}

const TermsConditionsSuccess = (data) => {
    return {
        type: actionTypes.BIZUM_REGISTER_TERMS_CONDITIONS_SUCCESS,
        payload: {
            data
        }
    }
}

const termsConditionsFailure = (error) => {
    return {
        type: actionTypes.BIZUM_REGISTER_TERMS_CONDITIONS_FAILURE,
        payload: {
            error
        }
    }
}

const BizumDataReset = () => {
    return {
        type: actionTypes.BIZUM_AUTHORIZE_SAVE_RESET,
    }
}

 // to unlock when we have endpoint of main terms and conditions
/*function requestTermsConditionsFailure(error) {
    return {
        type: actionTypes.BIZUM_REGISTER_TERMS_CONDITIONS_FAILURE,
        payload: {
            error
        }
    }
}*/

const requestBizumSetError = () => {
    return {
        type: actionTypes.BIZUM_REGISTER_SET_ERROR
    }
}

const sendTermsConditions = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().recoveryKeys.get('isFetching');
    const data = getState().userData.get('data');
    const immprofileEditor = getState().profileEditor;
    const email = immprofileEditor.get('steps').get(0).get('email');
    const clientName = getState().profile.get('nombreCliente');
    const phoneOTP = data.get('telefono') ? `+${data.get('telefono').replace(/[^0-9]/g, '')}` : "" ;

    if (!isAlreadyFetching) {
        const requestData = {
            header: {
                version: '2'
            },
            query: {
                name: clientName,
                email: email,
                telephone: phoneOTP
            }
        };

        taggingEvent({ 
            categoriaEvento: SEND_TERMS_AND_CONDITIONS_BUTTON,
            accionEvento: BIZUM_NEW_CUSTOMER,
            etiquetaEvento: CLICK_BUTTON_ACTION
        });

        dispatch(requestAccessDataInProgress());
        return APIPost(dispatch, apiURLBuilder.getURL('sendBizumTermsConditions'), requestData)
            .then(response => {
                taggingEvent({ 
                    categoriaEvento: SEND_TERMS_AND_CONDITIONS_BUTTON,
                    accionEvento: BIZUM_NEW_CUSTOMER,
                    etiquetaEvento: SEND_INFORMATION_BY_MAIL_BUTTON
                })

                dispatch(TermsConditionsSuccess(response))
            })
            .catch(({ error }) => {
                taggingEvent({ 
                    categoriaEvento: SEND_TERMS_AND_CONDITIONS_BUTTON,
                    accionEvento: VIEW_MESSAGE,
                    etiquetaEvento: FAILED_TO_SEND_MAIL_MESSAGE,
                    errorCategory: FAILED_TO_SEND_MAIL,
                    errorDescription: formatText('cc_portability-errorSendingMail')
                })

                dispatch(termsConditionsFailure(error))
            });
    }
};


const postAuthorizeBizumStart = () => ({
    type: actionTypes.BIZUM_AUTHORIZE_SAVE_START
});

const postAuthorizeBizumSuccess = response => ({
    type: actionTypes.BIZUM_AUTHORIZE_SAVE_SUCCESS,
    payload: Object.assign({}, response)
});

const postAuthorizeBizumPortability = response => ({
    type: actionTypes.BIZUM_REGISTER_WITH_PORTABILITY,
    payload: Object.assign({}, response)
});

const postAuthorizeBizumFailure = error => ({
    type: actionTypes.BIZUM_AUTHORIZE_SAVE_FAILURE,
    payload: {
        error
    }
});

const postAuthorizeBizumInvalidSecurityDataError = () => ({
    type: actionTypes.BIZUM_AUTHORIZE_INVALID_SECURITY_DATA_ERROR
});

const postAuthorizeBizumValidSecurityData = () => ({
    type: actionTypes.BIZUM_AUTHORIZE_VALID_SECURITY_DATA
});



const postAuthorizeBizum = () => (dispatch, getState) => {
    const { authorizeBizum, signaturePattern, printer } = getState();
    const isAlreadyFetching = authorizeBizum.get('isFetching');
    const securityData = getSecurityDataValid(signaturePattern, printer);
    const token = signaturePattern.get('token');

    if (!securityData) {
        dispatch(postAuthorizeBizumInvalidSecurityDataError());
        return;
    }

    dispatch(postAuthorizeBizumValidSecurityData());
    if (!isAlreadyFetching) {
        dispatch(postAuthorizeBizumStart());
        return authorizeBizumRequest(dispatch, getState, securityData, token)
        .then(responseAuthorizeClient => {
            if (responseAuthorizeClient.error === undefined || responseAuthorizeClient.error === ERROR_REGISTER_BIZUM_SUCCESSFUL) {// That is necessary because always the service respond with 200 http even if it has errors.
                dispatch(postAuthorizeBizumSuccess(responseAuthorizeClient));
            } else if(responseAuthorizeClient.error === ERROR_USER_REGISTERED_IN_OTHER_ENTITY) {
                dispatch(postAuthorizeBizumPortability(responseAuthorizeClient));
            }else if(responseAuthorizeClient.errorDescription === ERROR_BAD_REQUEST) {
                dispatch(postAuthorizeBizumInvalidSecurityDataError());
            } else {
                dispatch(postAuthorizeBizumFailure(responseAuthorizeClient.error));
            }
        })
        .catch(errorResponse => {
            if(!!errorResponse.error) {
                dispatch(postAuthorizeBizumFailure(errorResponse.body));
            } else {
                throw errorResponse;
            }
        });

    }
}

module.exports = {
    setVisibleStep,
    validateStep,
    onAccountChange,
    onAcceptTermsAndConditions,
    sendTermsConditions,
    postAuthorizeBizum,
    requestBizumSetError,
    BizumDataReset
}
